export class SiteOperationsEntity {
  id;
  siteId;
  userId;
  typeId;
  carEntity;
  carTokens;

  constructor(id, siteId, userId, typeId, carEntity = null, carTokens = null) {
    this.id=id;
    this.siteId = siteId;
    this.userId = userId;
    this.typeId = typeId;
    this.carEntity = carEntity;
    this.carTokens = carTokens;
  }
}
